"use client";

import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NuestraUbicaciN() {
  const header = useRevealOnScroll<HTMLDivElement>();
  const mapWrap = useRevealOnScroll<HTMLDivElement>();
  const logistics = useRevealOnScroll<HTMLDivElement>();
  const logisticsData = [{
    label: "COBERTURA OPERATIVA",
    value: "Despliegue táctico en toda la Zona Metropolitana"
  }, {
    label: "CENTRO DE MANDO",
    value: "Monitoreo 24/7 con respuesta inmediata garantizada"
  }, {
    label: "ATENCIÓN CORPORATIVA",
    value: "Citas presenciales para consultoría de riesgos"
  }];
  const partnerPins = [{
    top: "22%",
    left: "28%"
  }, {
    top: "34%",
    left: "62%"
  }, {
    top: "58%",
    left: "38%"
  }, {
    top: "44%",
    left: "78%"
  }, {
    top: "70%",
    left: "55%"
  }, {
    top: "28%",
    left: "48%"
  }, {
    top: "66%",
    left: "22%"
  }, {
    top: "52%",
    left: "70%"
  }];
  return <section data-section-id="5276" id="nuestra-ubicación" className="bg-background text-foreground pt-[120px] pb-0 px-4 sm:px-6 lg:px-12 font-default">
      <div className="max-w-[1400px] mx-auto">
        {}
        <div ref={header.ref} className={`mb-12 lg:mb-16 transition-all duration-700 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono text-xs tracking-[0.15em] text-primary mb-6">
            [ SEDE CENTRAL ]
          </p>
          <h2 className="font-serif font-default text-4xl sm:text-5xl md:text-6xl lg:text-[64px] leading-[1.1] tracking-tighter text-foreground mb-6">
            Nuestra <span className="italic">Ubicación</span>
          </h2>
          <p className="text-muted-foreground text-base sm:text-lg max-w-3xl font-default">
            Ubicados estratégicamente para garantizar tiempos de respuesta mínimos y supervisión constante en los principales sectores industriales y residenciales.
          </p>
        </div>

        {}
        <div ref={mapWrap.ref} className={`relative transition-all duration-1000 ease-out ${mapWrap.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="absolute -top-2 -left-2 w-8 h-8 border-t border-l border-primary/30 z-20 pointer-events-none" />
          <div className="absolute -top-2 -right-2 w-8 h-8 border-t border-r border-primary/30 z-20 pointer-events-none" />
          <div className="absolute -bottom-2 -left-2 w-8 h-8 border-b border-l border-primary/30 z-20 pointer-events-none" />
          <div className="absolute -bottom-2 -right-2 w-8 h-8 border-b border-r border-primary/30 z-20 pointer-events-none" />

          {}
          <div className="absolute top-4 left-4 sm:top-6 sm:left-6 z-20 font-mono text-[10px] sm:text-xs text-primary bg-background/80 backdrop-blur-md px-3 py-2 border border-border">
            19.4326° N / 99.1332° W
          </div>
          <div className="absolute top-4 right-4 sm:top-6 sm:right-6 z-20 font-mono text-[10px] sm:text-xs text-primary bg-background/80 backdrop-blur-md px-3 py-2 border border-border text-right">
            NIVEL DE ZOOM 12 / RADIO DE RESPUESTA 15KM
          </div>
          <div className="absolute bottom-16 left-4 sm:bottom-20 sm:left-6 z-20 font-mono text-[10px] sm:text-xs text-muted-foreground bg-background/80 backdrop-blur-md px-3 py-2 border border-border">
            ESTADO: OPERATIVO 24/7
          </div>
          <div className="absolute bottom-16 right-4 sm:bottom-20 sm:right-6 z-20 font-mono text-[10px] sm:text-xs text-muted-foreground bg-background/80 backdrop-blur-md px-3 py-2 border border-border text-right">
            UNIDADES DISPONIBLES: ACTIVAS
          </div>

          {}
          <div className="relative w-full h-[500px] sm:h-[600px] overflow-hidden border border-border bg-card shadow-xl">
            {}
            <div className="absolute inset-0 bg-background">
              {}
              <div className="absolute inset-0 opacity-20" style={{
              backgroundImage: "linear-gradient(to right, hsl(220 10% 22%) 1px, transparent 1px), linear-gradient(to bottom, hsl(220 10% 22%) 1px, transparent 1px)",
              backgroundSize: "60px 60px"
            }} />
              {}
              <svg className="absolute inset-0 w-full h-full" viewBox="0 0 1000 600" preserveAspectRatio="none" aria-hidden="true">
                <line x1="0" y1="180" x2="1000" y2="220" stroke="var(--primary)" strokeWidth="1" opacity="0.3" />
                <line x1="0" y1="380" x2="1000" y2="360" stroke="var(--primary)" strokeWidth="1" opacity="0.3" />
                <line x1="200" y1="0" x2="180" y2="600" stroke="var(--primary)" strokeWidth="1" opacity="0.3" />
                <line x1="500" y1="0" x2="520" y2="600" stroke="var(--primary)" strokeWidth="1.5" opacity="0.4" />
                <line x1="780" y1="0" x2="760" y2="600" stroke="var(--primary)" strokeWidth="1" opacity="0.3" />
                {}
                <path d="M 850 0 L 1000 0 L 1000 600 L 880 600 Q 870 400 890 300 Q 910 150 850 0 Z" fill="hsl(222 47% 11%)" opacity="0.4" />
              </svg>

              {}
              <div className="absolute border border-primary/20" style={{
              width: "55%",
              height: "75%",
              top: "12.5%",
              left: "22.5%",
              borderStyle: "dashed"
            }} />

              {}
              {partnerPins.map((pin, i) => <div key={i} data-index={i} className="absolute w-2 h-2 bg-primary/40" style={{
              top: pin.top,
              left: pin.left
            }} />)}

              {}
              <div className="absolute" style={{
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)"
            }}>
                <div className="relative flex items-center justify-center">
                  {}
                  <span className="absolute w-16 h-16 bg-primary/10 animate-ping" />
                  <span className="absolute w-10 h-10 bg-primary/20 animate-pulse" />
                  {}
                  <span className="relative w-4 h-4 bg-primary shadow-lg" />
                </div>

                {}
                <div className="absolute left-6 top-6 sm:left-8 sm:top-8 whitespace-nowrap bg-card border border-primary/40 px-4 py-3 shadow-2xl">
                  <div className="font-mono text-[10px] sm:text-xs text-primary tracking-wider">
                    POSEIDON HQ / CDMX
                  </div>
                  <div className="font-mono text-[9px] sm:text-[10px] text-muted-foreground mt-1 tracking-wider">
                    CENTRO DE OPERACIONES — ACTIVO
                  </div>
                </div>
              </div>
            </div>

            {}
            <div className="absolute bottom-4 right-4 sm:bottom-6 sm:right-6 z-20">
              <Button asChild variant="default" size="sm" className="font-mono text-[10px] sm:text-xs tracking-wider rounded-md bg-primary text-primary-foreground hover:bg-foreground hover:text-background transition-colors">
                <Link to="https://www.google.com/maps/search/?api=1&query=Mexico+City+Security+Agency" newTab>
                  VER EN MAPA
                  <ArrowUpRight className="size-3.5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 lg:mt-20">
          <Separator className="bg-primary/20 h-px" />
        </div>

        {}
        <div ref={logistics.ref} className={`grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 py-16 lg:py-20 transition-all duration-700 ease-out ${logistics.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {logisticsData.map((item, i) => <div key={i} data-index={i} className="flex flex-col gap-3">
              <p className="font-mono text-[11px] tracking-[0.15em] text-primary">
                [ {item.label} ]
              </p>
              <p className="text-foreground text-base sm:text-lg leading-snug font-default">
                {item.value}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}